import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { DATE_SHORTCUTS } from '@utils/constants';
import { calcShortcutInterval } from '@utils';
import DatePicker from '@src/components/common/DatePicker';

export const DatePickerModifier = (props) => {
  const pickerRef = useRef();

  const getDisabledDate = () => (currentDate) => {
    if (!currentDate) return true;
    return (
      currentDate.isAfter(moment(), 'day') ||
      currentDate.isBefore(moment().subtract(1, 'month'), 'day')
    );
  };

  useEffect(() => {
    if (pickerRef.current) {
      const modelOpen = pickerRef.current.isModelOpen();
      if (!modelOpen) {
        pickerRef.current.reset();
      }
    }
  }, [props.interval]);

  const shortcuts = [
    [DATE_SHORTCUTS.last2Hours, calcShortcutInterval(DATE_SHORTCUTS.last2Hours)],
    [DATE_SHORTCUTS.last6Hours, calcShortcutInterval(DATE_SHORTCUTS.last6Hours)],
    [DATE_SHORTCUTS.past24Hours, calcShortcutInterval(DATE_SHORTCUTS.past24Hours)],
    [DATE_SHORTCUTS.today, calcShortcutInterval(DATE_SHORTCUTS.today)],
    [DATE_SHORTCUTS.yesterday, calcShortcutInterval(DATE_SHORTCUTS.yesterday)],
    [DATE_SHORTCUTS.sevenDays, calcShortcutInterval(DATE_SHORTCUTS.sevenDays)],
    [DATE_SHORTCUTS.lastWeek, calcShortcutInterval(DATE_SHORTCUTS.lastWeek)],
    [DATE_SHORTCUTS.thirtyDays, calcShortcutInterval(DATE_SHORTCUTS.thirtyDays)],
    [DATE_SHORTCUTS.thisMonth, calcShortcutInterval(DATE_SHORTCUTS.thisMonth)],
  ];

  return (
    <DatePicker
      disabledDate={getDisabledDate()}
      shortcuts={shortcuts}
      ref={pickerRef}
      defaultValue={props.interval}
      {...props}
    />
  );
};
